<!--定时器配置页面-->
<template>
    <div class="mains">
        <!--左侧-->
        <a-col class="columns" style="float: left">
            <div ref="refLeftTopHeight">
                <a-row style="border: 1px solid #e8eaec;">
                    <a-col>
                        <a-button size="small" class="mg5" @click="query">{{$t('job.Query')}}</a-button>
                        <a-button size="small" class="mg5" @click="reset">{{$t('job.Reset')}}</a-button>
                        <a-button size="small" class="mg5" @click="deleteDetail">{{$t('job.Delete')}}</a-button>
                    </a-col>
                </a-row>
                <a-row>
                    <a-form :form="formQuery">
                        <a-col :span = "8" offset="1">
                            <a-form-item  class="genericFrom">
                                <b>{{$t('job.Name')}}</b>
                                <a-input size="small" v-decorator="['jobName']" @pressEnter="query"/>
                            </a-form-item>
                        </a-col>
                        <a-col :span = "8" offset="1">
                            <a-form-item class="genericFrom">
                                <b>{{$t('job.Class')}}</b>
                                <a-input size="small" v-decorator="['jobClass']" @pressEnter="query"/>
                            </a-form-item>
                        </a-col>
                    </a-form>
                </a-row>
                <a-row>
                    <a-col align="right" style="margin: 20px -7px 5px 0">
                        <!--分页-->
                        <a-pagination
                                :pageSizeOptions="pageSizeOptions"
                                :showTotal="total => $t('job.Total') + ` ${pagingTotal} `+$t('job.Records')"
                                size="small"
                                :total="pagingTotal"
                                v-model="currentVal"
                                :pageSize.sync="pagingSize"
                                @change="tableChangePage"
                                @showSizeChange="onShowSizeChange"
                                :showSizeChanger="showSizeChanger"
                                :showQuickJumper="showQuickJumper"
                        />
                    </a-col>
                </a-row>
            </div>
            <a-row>
                <!--列表-->
                <vxe-table
                        border
                        resizable
                        stripe
                        column-key
                        highlight-hover-column
                        highlight-hover-row
                        highlightCurrentRow
                        show-header-overflow
                        show-overflow
                        @cell-dblclick="editDetail"
                        :sort-config="{multiple: true, trigger: 'cell'}"
                        :edit-config="{trigger: 'click', mode: 'cell', showStatus: true}"
                        keep-source
                        :keyboard-config="{isArrow: true}"
                        :checkbox-config="{trigger: 'row', highlight: true, range: true}"
                        align="center"
                        :data.sync="PagingGridList"
                        class="mytable-style "
                        :height="getLeftHeight"
                        ref="refLeftPagingGrid"
                        size="mini">
                    <template v-slot:empty>
                        <a-empty></a-empty>
                    </template>
                    <vxe-table-column type="checkbox" width="35"></vxe-table-column>
                    <vxe-table-column field="uid" title="UID" show-header-overflow="ellipsis" show-overflow="title" :visible="false"></vxe-table-column>
                    <vxe-table-column field="jobName" :title="$t('job.Name')" width="30%" sortable></vxe-table-column>
                    <vxe-table-column field="jobClassName" :title="$t('job.Class')" width="30%" sortable></vxe-table-column>
                    <vxe-table-column field="remark" :title="$t('job.Remark')" sortable></vxe-table-column>
                </vxe-table>
            </a-row>
        </a-col>
        <!--右侧-->
        <a-col class="columns" style="margin-right: 1px;float: right">
            <div ref="refRightTopHeight">
                <a-row style="border: 1px solid #e8eaec;">
                    <a-button size="small" class="mg5" @click="add">{{$t('job.Add')}}</a-button>
                    <a-button size="small" class="mg5" @click="saveDetail">{{$t('job.Save')}}</a-button>
                </a-row>
                <a-row>
                    <a-form :form="formSave">
                        <a-row>
                            <a-col :span = "10">
                                <a-form-item class="genericFrom" label="UID" v-show="false">
                                    <a-input v-decorator="[
                                                    'uid',
                                                    {
                                                        initialValue: this.jobDetail == null ? '' : this.jobDetail.uid
                                                    }]
                                                "/>
                                </a-form-item>
                                <a-form-item  class="genericFrom">
                                    <b>{{$t('job.Name')}}<span style="color: red">*</span></b>
                                    <a-input size="small" v-decorator="[
                                                    'jobName',
                                                    {
                                                        initialValue: this.jobDetail == null ? '' : this.jobDetail.jobName,
                                                        rules: [
                                                            {
                                                              required: true,
                                                              message: $t('publicLang.Required'),
                                                            }
                                                        ]
                                                    }]"/>
                                </a-form-item>
                            </a-col>
                            <a-col :span = "5" offset="1">
                                <a-form-item class="genericFrom" aria-required="true">
                                    <b>{{$t('job.Type')}}<span style="color: red">*</span></b>
                                    <a-select size="small" v-decorator="[
                                                    'jobType',
                                                    {
                                                        initialValue: this.jobDetail == null ? 'java' : this.jobDetail.jobType
                                                    }]">
                                        <a-select-option value="java">Java</a-select-option>
                                        <a-select-option value="procedure">Procedure</a-select-option>
                                    </a-select>
                                </a-form-item>
                            </a-col>
                        </a-row>
                        <a-row>
                            <a-col :span = "16">
                                <a-form-item class="genericFrom">
                                    <b>{{$t('job.Remark')}}</b>
                                    <a-textarea v-decorator="[
                                                    'remark',
                                                    {
                                                        initialValue: this.jobDetail == null ? '' : this.jobDetail.remark
                                                    }]"></a-textarea>
                                </a-form-item>
                            </a-col>
                        </a-row>
                        <a-row>
                            <a-col :span = "16">
                                <a-form-item class="genericFrom">
                                    <b>{{$t('job.Class')}}<span style="color: red">*</span></b>
                                    <a-input size="small" v-decorator="[
                                                    'jobClassName',
                                                    {
                                                        initialValue: this.jobDetail == null ? '' : this.jobDetail.jobClassName,
                                                        rules: [
                                                            {
                                                              required: true,
                                                              message: $t('publicLang.Required'),
                                                            }
                                                        ]
                                                    }]
                                                "/>
                                </a-form-item>
                            </a-col>
                        </a-row>
                    </a-form>
                </a-row>
                <a-row style="border: 1px solid #e8eaec;margin-top: 5px;">
                    <a-button size="small" class="mg5" @click="addParam(-1)">{{$t('job.Add')}}</a-button>
                    <a-button size="small" class="mg5" @click="saveParam">{{$t('job.Save')}}</a-button>
                    <a-button size="small" class="mg5" @click="deleteParam">{{$t('job.Delete')}}</a-button>
                </a-row>
            </div>
            <a-row>
                <!--列表-->
                <vxe-table
                        border
                        resizable
                        stripe
                        column-key
                        highlight-hover-column
                        highlight-hover-row
                        highlightCurrentRow
                        show-header-overflow
                        show-overflow
                        :sort-config="{multiple: true, trigger: 'cell'}"
                        :edit-config="{trigger: 'click', mode: 'cell', showStatus: true}"
                        :edit-rules="validRules"
                        keep-source
                        :keyboard-config="{isArrow: true}"
                        :checkbox-config="{trigger: 'row', highlight: true, range: true}"
                        align="center"
                        :data.sync="PagingGridParamList"
                        class="mytable-style "
                        :height="getRightHeight"
                        ref="refRightPagingGrid"
                        size="mini">
                    <template v-slot:empty>
                        <a-empty></a-empty>
                    </template>
                    <vxe-table-column type="checkbox" width="35"></vxe-table-column>
                    <vxe-table-column field="uid" title="UID" show-header-overflow="ellipsis" show-overflow="title" :visible="false"></vxe-table-column>
                    <vxe-table-column field="jobDetailUid" title="UID" show-header-overflow="ellipsis" show-overflow="title" :visible="false"></vxe-table-column>
                    <vxe-table-column field="seq" type="seq" :title="$t('job.Seq')" width="70px" sortable></vxe-table-column>
                    <vxe-table-column field="parameterName" :title="$t('job.ParamName')" width="25%" sortable :edit-render="{name: 'input'}"></vxe-table-column>
                    <vxe-table-column field="value" :title="$t('job.ParamValue')" width="25%" sortable :edit-render="{name: 'input'}"></vxe-table-column>
                    <vxe-table-column field="remark" :title="$t('job.Remark')" sortable :edit-render="{name: 'input'}"></vxe-table-column>
                </vxe-table>
            </a-row>
        </a-col>
    </div>
</template>

<script>
    import ajax from "../../api/ajax";
    import cookie from '../../api/cookie';
    import api from "../../api/url";

    export default{
        data(){
            return{
                pagingTotal: 0, // 总数
                pagingSize: 20,  // 条数
                currentVal: 1, // 当前选中的页数
                showSizeChanger:true,//是否显示页码下拉框
                showQuickJumper:false,//是否显示快速跳转输入框
                pageSizeOptions:['10', '20', '30', '40','100','200','500','1000'],
                PagingGridList: [],//列表数据
                PagingGridParamList: [],//列表数据
                formQuery: this.$form.createForm(this, {}),
                formSave: this.$form.createForm(this, {}),
                leftTopHeight: 0,
                rightTopHeight: 0,
                jobType:'Java',
                jobDetail:null,
                validRules: {
                    parameterName: [
                        { required: true, message: this.$t('job.notNull') }
                    ],
                    value: [
                        { required: true, message: this.$t('job.notNull') }
                    ]
                }
            }
        },
        mounted() {
            this.leftTopHeight = this.$refs.refLeftTopHeight.clientHeight;//左侧列表上部份div的高度
            this.rightTopHeight = this.$refs.refRightTopHeight.clientHeight;//右侧列表上部份div的高度
        },
        computed:{
            getLeftHeight(){
                return document.body.clientHeight - this.leftTopHeight - 100;//自适应查询列表的高度
            },
            getRightHeight(){
                return document.body.clientHeight - this.rightTopHeight - 100;//自适应查询列表的高度
            },
        },
        created() {
            this.query();
        },
        methods:{
            query(){
                this.add();
                this.formQuery.validateFields((err, values) => {
                    if(err){
                        this.$customMessage.warning(this.$t('publicLang.InputRequiredValue'), 2);
                        return;
                    }
                    if(values){
                        let params = {//配置查询条件
                            jobName : values.jobName,
                            jobClass : values.jobClass,
                            currentVal : (this.currentVal - 1) * this.pagingSize,
                            pagingSize : this.pagingSize,
                        }
                        ajax.get(api.JOBLIST,params).then(res=>{
                            if(res.code == 200){
                                this.PagingGridList = res.data;//列表
                                this.pagingTotal = res.total;//总数
                            }
                        })
                    }
                });
            },
            cleardata(){
                this.reset();
            },
            reset(){
                this.formQuery.resetFields();
            },
            add(){
                this.jobDetail = null;
                this.formSave.resetFields();
                this.PagingGridParamList = null;
            },
            queryParam(uid){
                let params = {//配置查询条件
                    jobDetailUid : uid,
                }
                ajax.get(api.JOBPARAMLIST,params).then(res=>{
                    if(res.code == 200){
                        this.PagingGridParamList = res.data;//列表
                    }
                })
            },
            saveDetail(){
                this.formSave.validateFields((err, values) => {
                    if(err){
                        this.$customMessage.warning(this.$t('publicLang.InputRequiredValue'), 2);
                        return;
                    }
                    if(values){
                        ajax.post(api.JOBSAVEDETAIL, values).then(res => {
                            if (res.code == 200) {
                                this.query()
                                this.$message.success(res.msg,2)
                                this.jobDetail = res.data;
                                this.queryParam(this.jobDetail.uid);
                            } else {
                                this.$customMessage.warning(res.msg,2);
                            }
                        })
                    }
                });
            },
            deleteDetail(){
                let Records = this.$refs.refLeftPagingGrid.getCheckboxRecords()
                if(Records.length == 0){
                    this.$customMessage.warning(this.$t('publicLang.PleaseSltAtleast'), 2);
                    return;
                }
                let uidList = [];
                for(let i in Records){
                    uidList.push(Records[i].uid)
                }
                let that = this;
                this.$customConfirm({
                    title: that.$t('pubGicSet.AreyoudeleTask'),
                    okText: that.$t('publicLang.Confirm'),
                    cancelText: that.$t('publicLang.Cancel'),
                    content: "",
                    onOk() {
                        let params = new FormData();
                        params.append("uidList", uidList);
                        ajax.post(api.DELETEJOBDETAIL, params).then(res => {
                            if (res.code == 200) {
                                that.query()
                                that.$message.success(that.$t("publicLang.DeleteSuccess"));
                            } else {
                                that.$customMessage.error(res.msg);
                            }
                        })
                    }
                });
            },
            tableChangePage(current) {
                this.currentVal = current;
                this.query();
            },
            onShowSizeChange(current, pageSize) {//选择下拉框后触发事件
                this.currentVal = current;
                this.pagingSize = pageSize;
                this.query();
            },
            editDetail({ row }) {//双击显示修改和查询定时器参数明细
                //查询主表数据
                let params = {
                    uid: row.uid
                }
                ajax.get(api.JOBDETAIL,params).then(res=>{
                    this.formSave.resetFields();
                    this.jobDetail = res.data;
                    //查询明细数据
                    this.queryParam(row.uid);
                })
            },
            addParam(row){
                if(this.jobDetail == null || this.jobDetail.uid == null){
                    this.$customMessage.warning(this.$t('asnPage.saveHeaderPlease'),2);
                    return;
                }
                let refRight = this.$refs.refRightPagingGrid;
                let record = {
                    jobDetailUid : this.jobDetail.uid
                }
                refRight.insertAt(record, row).then(({ row }) => {
                    refRight.setActiveCell(row,'parameterName')
                })
            },
            saveParam(){
                let Records = this.$refs.refRightPagingGrid.getRecordset();
                let insertRecords = Records.insertRecords
                let updateRecords = Records.updateRecords
                let removeRecords = Records.removeRecords
                if(insertRecords.length == 0 && updateRecords.length == 0 && removeRecords == 0){
                    this.$customMessage.warning(this.$t('asnPage.saveData'),2);
                    return;
                }
                for (let i = 0; i < insertRecords.length; i++) {
                    if(insertRecords[i].parameterName == null ||insertRecords[i].parameterName.length == 0){
                        this.$customMessage.warning(this.$t('job.Seq')+ ":" + insertRecords[i].seq + " " + this.$t('job.ParamName') + this.$t('job.notNull'),2);
                        return;
                    }
                    if(insertRecords[i].value == null || insertRecords[i].value.length == 0){
                        this.$customMessage.warning(this.$t('job.Seq')+ ":" + insertRecords[i].seq + " " + this.$t('job.ParamValue') + this.$t('job.notNull'),2);
                        return;
                    }
                }
                for (let i = 0; i < updateRecords.length; i++) {
                    if(updateRecords[i].parameterName == null || updateRecords[i].parameterName.length == 0){
                        this.$customMessage.warning(this.$t('job.Seq')+ ":" + updateRecords[i].seq + " " + this.$t('job.ParamName') + this.$t('job.notNull'),2);
                        return;
                    }
                    if(updateRecords[i].value == null ||updateRecords[i].value.length == 0){
                        this.$customMessage.warning(this.$t('job.Seq')+ ":" + updateRecords[i].seq + " " + this.$t('job.ParamValue') + this.$t('job.notNull'),2);
                        return;
                    }
                }
                let params = {
                    insertRecords : insertRecords,
                    updateRecords : updateRecords,
                    removeRecords : removeRecords
                }
                ajax.post(api.JOBSAVEPARAM, params).then(res => {
                    if (res.code == 200) {
                        this.$message.success(res.msg,2)
                        this.queryParam(this.jobDetail.uid);
                    } else {
                        this.$customMessage.warning(res.msg,2);
                    }
                })
            },
            deleteParam(){
                this.$refs.refRightPagingGrid.removeCheckboxRow()
            }
        }
    }
</script>

<style lang="less">
    .mains{
        height: 100%;
        width: 100%;
        background-color: white;
        float: left;
    }
    .columns{
        width: 49.6%;
        height: 100%;
    }
</style>